import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	notAvailableMessage: {
		id: 'software.main.board-container.board.column.transition-zones-container.not-available-message',
		defaultMessage: 'A workflow rule prevents you from moving the issue this way.',
		description: 'message for when the drop zone is restricted',
	},
	noTransitionMessage: {
		id: 'software.main.board-container.board.column.transition-zones-container.no-transition-message',
		defaultMessage:
			"You can't move this issue to this column due to workflow configurations or permissions.",
		description: 'message for when no drop zone is available',
	},
	notAvailableMessageIssueTermRefresh: {
		id: 'software.main.board-container.board.column.transition-zones-container.not-available-message-issue-term-refresh',
		defaultMessage: 'A workflow rule prevents you from moving the work item this way.',
		description: 'message for when the drop zone is restricted',
	},
	noTransitionMessageIssueTermRefresh: {
		id: 'software.main.board-container.board.column.transition-zones-container.no-transition-message-issue-term-refresh',
		defaultMessage:
			"You can't move this work item to this column due to workflow configurations or permissions.",
		description: 'message for when no drop zone is available',
	},
});
